module.exports = __webpack_public_path__ + "77cd824612d4cb3b90a133f2f94e7edb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/11.jpg
// module id = 1337
// module chunks = 47